import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useContext } from 'react';
import { IconButton } from '@mui/material';
import { PriceChange } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// Internal dependencies
import { ButtonSG } from '../../components';
import { CLIENT_ENDPOINTS } from '../../constants';
import { UserContext } from '../../auth';
import { TabNamesTypes } from '../../settings';
import { appStyles } from '../../App.styles';
/**
 * Upgrade Plan Button
 * @param {ButtonProps} props
 * @returns {JSX.Element}
 */
export const UpgradePlanSG = function (props) {
    // Extract translation function
    const { t } = useTranslation();
    // Load user credential
    const user = useContext(UserContext);
    // Use React Router Dom navigate
    const navigate = useNavigate();
    const { handleDrawerToggle } = props;
    /**
     * Handle Upgrade plan click
     */
    const handleUpgradeClick = () => {
        navigate(CLIENT_ENDPOINTS.SETTINGS + '/?tab=' + TabNamesTypes.Subscription);
        if (handleDrawerToggle) {
            // If it's in the side bar
            handleDrawerToggle();
        }
        return true;
    };
    return (_jsxs(_Fragment, { children: [_jsx(ButtonSG
            // Upgrade button for desktop
            , Object.assign({ "aria-label": "Upgrade Button", variant: "contained", color: "blueLight", onClick: handleUpgradeClick, sx: Object.assign(Object.assign({}, appStyles.text14), { boxShadow: 'none', padding: '0.375rem 1rem', display: {
                        xs: 'none',
                    }, borderRadius: '0.5rem', color: 'blackLight.main' }) }, { children: t('UPGRADE') })), _jsx(IconButton
            // Upgrade button for mobile
            , Object.assign({ "aria-label": "Upgrade Button", onClick: handleUpgradeClick }, { children: _jsx(PriceChange, { sx: { color: 'blackDark.main' } }) }))] }));
};
